"use strict";
/**
 * Copyright 2014-present Palantir Technologies
 * @license MIT
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeEnum = void 0;
function makeEnum(values) {
    return values.reduce(function (obj, v) {
        obj[v] = v;
        return obj;
    }, {});
}
exports.makeEnum = makeEnum;



//////////////////
// WEBPACK FOOTER
// ./src/utils/makeEnum.ts
// module id = 11
// module chunks = 0